import React from 'react';
import { connect } from 'react-redux';
import configuration from '../../constants/Configuration';
import { VolumeBar } from '../videoEditor/VolumeBar';
import { VideoTrack } from '../videoEditor/VideoTrack';
import { TotalDurationView } from '../videoEditor/TotalDurationView';
import properties from '../../constants/Properties';
import { changeContextMode, showVideoEditor } from '../../actions/MenuActions';
import { updateCurrentSlide } from '../../actions/ProductionActions';
import mouseUtils from '../../components/utils/MouseUtils';
import videoUtils from '../utils/VideoUtils';
import appParameters from '../../components/utils/AppParameters';
import { changeBackgroundContent, changeSlideDuration, updateCurrentSlideThumbnail } from '../../actions/CurrentSlideActions';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import hoverManager from '../utils/HoverManager';
import modeType from '../../constants/ModeConstants';
import storeManager from '../../store/StoreManager';
import playController from '../utils/PlayController';
import saveManager from '../utils/SaveManager';
import locales from "../../locales/LocalesManager";

const VideoEditorContent = React.createClass({
    getInitialState() {
        return {
            isPlayButtonOver: false,
            isPlaying: false,
            isCancelOver: false,
            isOkOver: false
        };
    },
    componentDidMount() {
        videoUtils.videoEndedCallback = this.onVideoEnded;
        videoUtils.executeAction = this.executeAction;
    },
    onCancelMouseIn() {
        hoverManager.show(this.refs.cancel, 'cancelVideo', 'left');

        this.setState({
            isCancelOver: true
        });
    },
    clearEditorElements(updateStartPoint = true) {
        this.setState({
            isPlayButtonOver: false,
            isPlaying: false,
            isCancelOver: false,
            isOkOver: false
        });

        videoUtils.resetCurrentProperties(updateStartPoint);

        this.updatePlayButtonFocus();
    },
    updatePlayButtonFocus() {
        setTimeout(function () {
            if (this.refs.play)
                this.refs.play.focus();
        }.bind(this), 500);
    },
    resetAction() {
        this.clearEditorElements();
        this.props.dispatch(updateCurrentSlideThumbnail(true));
        this.props.dispatch(showVideoEditor(false));

        hoverManager.hide();
    },
    onCancelMouseOut() {
        hoverManager.hide();

        this.setState({
            isCancelOver: false
        });
    },
    onCancelClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.executeCancelAction();
    },
    executeCancelAction() {
        this.addPreviewBackgroundState();

        audioEditorUtils.checkTimelineWidth();
        this.resetAction();

        playController.updateScrollPosition(500);
        videoUtils.currentSlideModel = undefined;

        saveManager.isContentChanged(true);
        saveManager.autoSave();
    },
    addPreviewBackgroundState() {
        if (videoUtils.currentSlideModel) {
            let slide = videoUtils.currentSlideModel;
            let background = slide.content[0];
            let newContent = {};

            newContent.href = background.xlinkHref;

            if (background.logicalName)
                newContent.logicalName = background.logicalName;

            if (background.contentItemId)
                newContent.contentItemId = background.contentItemId;

            if (background.frameLabel)
                newContent.frameLabel = background.frameLabel;

            if (background.moods)
                newContent.moods = background.moods;

            if (background.hotSpot)
                newContent.hotSpot = background.hotSpot;

            if (background.theme)
                newContent.theme = background.theme;

            if (background.isVideo) {
                newContent.isVideo = background.isVideo;
                newContent.volume = background.volume;
                newContent.inPoint = background.inPoint;
                newContent.outPoint = background.outPoint;
            }

            if (background.orgWidth >= 0) {
                newContent.orgWidth = background.orgWidth;
                newContent.orgHeight = background.orgHeight;
            }

            if (background.fill) {
                newContent.fill = background.fill;
                newContent.fillOpacity = background.fillOpacity;
            }

            if (background.stroke) {
                newContent.stroke = background.stroke;
                newContent.strokeOpacity = background.strokeOpacity;
            }

            this.props.dispatch(changeBackgroundContent(newContent));
            this.props.dispatch(changeSlideDuration(slide.time));
        }
    },
    onOkMouseIn() {
        hoverManager.show(this.refs.ok, 'okVideo');

        this.setState({
            isOkOver: true
        });
    },
    onOkMouseOut() {
        hoverManager.hide();

        this.setState({
            isOkOver: false
        });
    },
    onCanvasClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (storeManager.getState().menu.contextMode != modeType.SEARCH_CONTEXT) // if is Search menu then don't hide
            this.props.dispatch(changeContextMode(modeType.CONTEXT_NONE));
    },
    onOkClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.executeOkAction();
    },
    executeOkAction() {
        audioEditorUtils.refreshAllSlidesRenderers = true;
        videoUtils.updateNewVideoProperties();
        this.props.dispatch(updateCurrentSlide());

        audioEditorUtils.checkTimelineWidth();

        this.resetAction();

        playController.updateScrollPosition(500);
        saveManager.isContentChanged(true);
        audioEditorUtils.addActionToHistory();

        setTimeout(function() {
            videoUtils.prepareMultipleVideos(false);
        }.bind(this), 500);

        videoUtils.currentSlideModel = undefined;
    },
    onPlayButtonMouseIn () {
        hoverManager.show(this.refs.play, 'playVideo');

        this.setState({
            isPlayButtonOver: true
        });
    },
    onPlayButtonMouseOut () {
        hoverManager.hide();

        this.setState({
            isPlayButtonOver: false
        });
    },
    onPlay(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.executePlayAction();
    },
    executePlayAction() {
        if (!this.state.isPlaying)
            videoUtils.playBackgroundVideo();
        else
            videoUtils.pauseBackgroundVideo();

        this.setState({
            isPlaying: !this.state.isPlaying
        });
    },
    executeAction(action) {
        switch(action) {
            case 'play': {
                this.executePlayAction();
                break;
            }
            case 'ok': {
                this.executeOkAction();
                break;
            }
            case 'cancel': {
                this.executeCancelAction();
                break;
            }
            case 'reset': {
                this.resetAction();
                break;
            }
            case 'clear': {
                this.clearEditorElements(false);
                break;
            }
            case 'focus': {
                this.updatePlayButtonFocus();
                break;
            }
        }
    },
    onVideoEnded() {
        this.setState({
            isPlaying: false
        });
    },
    getScaleFactor() {
        var freeHeight = this.props.scaleProperties.scale * configuration.CANVAS_HEIGHT - 10 - 170;
        return freeHeight / configuration.CANVAS_HEIGHT;
    },
    render() {
        const scaleProperties = this.props.scaleProperties;
        var menuStyle = {
            position: 'absolute',
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            top: scaleProperties.topY,
            left: scaleProperties.topX,
            width: configuration.CANVAS_WIDTH * scaleProperties.scale,
            height: configuration.CANVAS_HEIGHT * scaleProperties.scale
        };

        var appElement = document.getElementById('app');
        var scaleFactor = scaleProperties.scale;

        if (this.props.showVideoEditor) {
            scaleFactor = this.getScaleFactor();
            menuStyle.backgroundColor = '#707070';

            if (appElement)
                appElement.style.backgroundColor = '#707070';
        } else {
            if (appElement)
                appElement.style.backgroundColor = '#F2F2F2';
        }

        const videoScaleTransform = `scale(${scaleFactor})`;
        var letPosition = (configuration.CANVAS_WIDTH * scaleFactor - configuration.CANVAS_WIDTH) / 2;
        var topPosition = (configuration.CANVAS_HEIGHT * scaleFactor - configuration.CANVAS_HEIGHT) / 2;

        var videoHolderStyle = {
            position: 'absolute',
            top: topPosition,
            left: letPosition,
            width: configuration.CANVAS_WIDTH,
            height: configuration.CANVAS_HEIGHT,
            transform: videoScaleTransform,
            WebkitTransform: videoScaleTransform
        };

        if (this.props.showVideoEditor) {
            videoHolderStyle.left = letPosition + (configuration.CANVAS_WIDTH * scaleProperties.scale - configuration.CANVAS_WIDTH * scaleFactor) / 2;
            videoHolderStyle.top = topPosition + 10;

            videoUtils.getInitialProperties(configuration.CANVAS_WIDTH * scaleFactor);

            var buttonSize = 60;
            var trackHeight = 50;
            var borderColor;
            var iconColor;
            var trackLeft = (configuration.CANVAS_WIDTH * scaleProperties.scale - configuration.CANVAS_WIDTH * scaleFactor) / 2;
            var trackBarPosition = configuration.CANVAS_HEIGHT * scaleProperties.scale - 110;
            var buttonTopPosition = trackBarPosition - (buttonSize - trackHeight) / 2;
            var buttonGap = (trackLeft - buttonSize) / 2 - 2;
            var srcCancel = appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png';

            //CANCEL button
            if (this.state.isCancelOver) {
                iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
                srcCancel = appParameters.RESOURCES_LOCATION() + 'assets/exit_edit_hover.png';
            } else {
                iconColor = 'white';
            }

            const offset = ((this.props.windowWidth - this.props.accordionWidth) - configuration.CANVAS_WIDTH * scaleProperties.scale) / 2;
            const cancelButtonStyle = {
                position: 'absolute',
                left: configuration.CANVAS_WIDTH * scaleProperties.scale - buttonSize + offset,
                top: 11 - scaleProperties.topY,
                width: 40,
                height: 40,
                userDrag: 'none',
                WebkitUserSelect: 'none',
                userSelect: 'none',
                margin: 0,
                padding: 0,
                fontSize: 'initial',
                boxSizing: 'initial',
                borderStyle: 'none',
                background: 'none'
            };

            const cancelIconStyle = {
                position: 'absolute',
                top: 3,
                left: 4,
                color: iconColor
            };

            //OK button
            if (this.state.isOkOver) {
                borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
                iconColor = borderColor;
            } else {
                borderColor = 'white';
                iconColor = '#272727'
            }

            const okButtonStyle = {
                position: 'absolute',
                left: configuration.CANVAS_WIDTH * scaleProperties.scale - buttonSize - buttonGap,
                top: buttonTopPosition,
                width: buttonSize,
                height: buttonSize,
                background: 'white',
                borderRadius: 50,
                userDrag: 'none',
                WebkitUserSelect: 'none',
                userSelect: 'none',
                borderColor: borderColor,
                borderWidth: 2,
                borderStyle: 'solid',
                margin: 0,
                padding: 0,
                fontSize: 'initial',
                boxSizing: 'initial'
            };

            const okStyle = {
                position: 'absolute',
                top: 15,
                left: 15,
                color: iconColor
            };

            //play button
            if (this.state.isPlayButtonOver == true) {
                borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
                iconColor = borderColor;
            } else {
                borderColor = 'white';
                iconColor = '#272727'
            }

            const playStyle = {
                position: 'absolute',
                left: buttonGap,
                top: buttonTopPosition,
                width: buttonSize,
                height: buttonSize,
                background: 'white',
                borderRadius: 50,
                userDrag: 'none',
                WebkitUserSelect: 'none',
                userSelect: 'none',
                borderColor: borderColor,
                borderWidth: 2,
                borderStyle: 'solid',
                margin: 0,
                padding: 0,
                fontSize: 'initial',
                boxSizing: 'initial'
            };

            var playIcon = 'fa fa-play fa-2x';
            var playIconPosition = 21;

            if (this.state.isPlaying) {
                playIcon = 'fa fa-pause fa-2x';
                playIconPosition = 17;
            }

            const playIconStyle = {
                position: 'absolute',
                top: 14,
                left: playIconPosition,
                color: iconColor
            };

            const size = 48;

            const loaderStyle = {
                position: 'absolute',
                top: videoHolderStyle.height / 2 - size / 2,
                left: videoHolderStyle.width / 2 - size / 2,
                color: 'white',
                display: 'none'
            };

            return (
                <div style={menuStyle}>
                    <div style={videoHolderStyle} onTouchEnd={this.onCanvasClick} onClick={this.onCanvasClick}>
                        <video id='videoBackground' width={configuration.CANVAS_WIDTH} height={configuration.CANVAS_HEIGHT} className='audioItem' playsInline/>
                        <i id='videoPreloader' style={loaderStyle} className="fa fa-spinner fa-pulse fa-2x"/>
                    </div>

                    <button aria-label={locales.getCaption('cancelVideo', 'hover')} ref='cancel' style={cancelButtonStyle} onTouchEnd={this.onCancelClick} onClick={this.onCancelClick} onMouseOver={this.onCancelMouseIn} onMouseOut={this.onCancelMouseOut}>
                        <img alt='' aria-hidden='true' style={cancelIconStyle} src={srcCancel}/>
                    </button>
                    <button aria-label={locales.getCaption('playVideo', 'hover')} ref='play' style={playStyle} onMouseOver={this.onPlayButtonMouseIn} onMouseOut={this.onPlayButtonMouseOut} onClick={this.onPlay} onTouchEnd={this.onPlay}>
                        <i style={playIconStyle} className={playIcon}></i>
                    </button>
                    <VideoTrack dispatch={this.props.dispatch} width={configuration.CANVAS_WIDTH * scaleFactor} height={50} globalLeft={trackLeft + menuStyle.left} left={trackLeft} top={trackBarPosition} refreshVideoEditor={this.props.refreshVideoEditor}/>
                    <button aria-label={locales.getCaption('okVideo', 'hover')} ref='ok' style={okButtonStyle} onTouchEnd={this.onOkClick} onClick={this.onOkClick} onMouseOver={this.onOkMouseIn} onMouseOut={this.onOkMouseOut}>
                        <i style={okStyle} className="fa fa-check fa-2x"></i>
                    </button>

                    <VolumeBar scaleProperties={scaleProperties} refreshVideoEditor={this.props.refreshVideoEditor} windowHeight={this.props.windowHeight} windowWidth={this.props.windowWidth} accordionWidth={this.props.accordionWidth}/>
                    <TotalDurationView buttonSize={trackHeight} scaleProperties={scaleProperties} refreshVideoEditor={this.props.refreshVideoEditor} windowHeight={this.props.windowHeight}/>
                </div>
            );
        } else {
            const size = 48;

            const loaderStyle = {
                position: 'absolute',
                top: videoHolderStyle.height / 2 - size / 2,
                left: videoHolderStyle.width / 2 - size / 2,
                color: 'black',
                display: 'none'
            };

            var fillColor = (this.props.currentSlide && this.props.currentSlide.model) ? this.props.currentSlide.model.content[0].fill : '#ffffff';
            videoHolderStyle.background = fillColor;

            return (
                <div style={menuStyle}>
                    <div style={videoHolderStyle}>
                        <video id='videoBackground' width={configuration.CANVAS_WIDTH} height={configuration.CANVAS_HEIGHT} className='audioItem' preload="auto" playsInline/>
                        <div id='multipleVideos'/>
                        <i id='videoPreloader' style={loaderStyle} className="fa fa-spinner fa-pulse fa-2x"/>
                    </div>
                </div>
            );
        }
    }
});

function mapStateToProps(state) {
    var showVideoEditor = state.menu.showVideoEditor;
    var refreshVideoEditor = state.menu.refreshVideoEditor;
    var currentSlide = state.currentSlide;

    if (!showVideoEditor)
        showVideoEditor = false;

    return {
        showVideoEditor,
        refreshVideoEditor,
        currentSlide
    };
}

export const VideoEditor = connect(mapStateToProps)(VideoEditorContent);



/** WEBPACK FOOTER **
 ** ./src/components/videoEditor/VideoEditor.js
 **/